import { Component, effect, EventEmitter, Output } from '@angular/core';
import { toplinks } from '@shared/interfaces/interfaces';
import { DdtopnavComponent } from '@shared/library/ddtopnav/ddtopnav.component';
import { DdtopnavlinksComponent } from '@shared/library/ddtopnavlinks/ddtopnavlinks.component';
import { ProjectService } from '@core/services/project/project.service';
import { AuthService } from '@core/services/auth/auth.service';
import { forkJoin } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { ThemeService } from '@shared/services/theme/theme.service';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { DialogModule } from 'primeng/dialog';
import { Router } from '@angular/router';
import { NotificationService } from '@modules/notification/service/notification.service';
import { Notification } from '@modules/notification/interface/notification.interface';
import { BadgeModule } from 'primeng/badge';
import { NotificationComponent } from '@modules/notification/notification.component';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { FilterService } from '@modules/search/services/filter.service';
import { LabelsService } from '@modules/search/services/labels.service';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-topnav',
  standalone: true,
  imports: [
    DdtopnavComponent,
    DdtopnavlinksComponent,
    ButtonModule,
    MenuModule,
    AvatarModule,
    DialogModule,
    BadgeModule,
    NotificationComponent,
    FormsModule,
    DropdownModule,
    SelectButtonModule,
    SkeletonModule,
    CommonModule,
    SvgIconComponent,
    TooltipModule,
  ],
  templateUrl: './topnav.component.html',
  styleUrl: './topnav.component.scss',
})
export class TopnavComponent {
  links: toplinks[] = [
    { name: 'Search', url: '/search' },
  ];

  tenantItems: any[] = [];
  profileItems: any[] = [
    {
      label: 'Profile',
      items: [
        {
          label: 'Logout',
          icon: 'pi pi-sign-out',
          command: () => {
            this.logout();
          },
        },
      ],
    },
    {
      separator: true,
    },
  ];
  setttingIcon: string | undefined = 'settings';
  userImageUrl: string = '';
  isSettingsDialogVisible: boolean = false;
  currentProject: any = {};
  isFetchingDetails: boolean = true;
  newNotifications: Notification[] = [];
  isAllNotificationsVisible: boolean = false;
  showProjectSelectionDialog: boolean = false;
  showProjectSwitchDialog: boolean = false;
  selectedProject: string = '';
  dropdownSelect: any = null;
  contextOptions = [
    { label: 'Workspace', value: 'workspace' },
    { label: 'Comment', value: 'comment' },
    { label: 'Shared', value: 'shared' },
    { label: 'Claim Status Change', value: 'claim_status_change' },
  ];
  notificationOptions = [
    { label: 'All', value: 'all' },
    { label: 'Unread', value: 'notviewed' },
    { label: 'Read', value: 'viewed' },
  ];
  selectedContext: { label: String; value: String } | null = null;
  selectedNotificationOption: { label: String; value: String } =
    this.notificationOptions[0];
  @Output() loading = new EventEmitter();
  constructor(
    protected _project: ProjectService,
    protected _auth: AuthService,
    private _theme: ThemeService,
    private _router: Router,
    protected notificationService: NotificationService,
    private _filter: FilterService,
    private _label: LabelsService,
    private _messageService: MessageService
  ) {
    this.getUserDetailsAndProjects();
    this.getUserList();
    this.getNewNotifications();

    effect(() => {
      if (
        this._auth.userDetail() &&
        this._auth.userDetail()?.isPasswordUpdatedByUser !== undefined &&
        !this._auth.userDetail()?.isPasswordUpdatedByUser
      ) {
        this._router.navigate(['change-password']);
      } else if (
        this._auth.userDetail() &&
        this._auth.userDetail()?.isTfaConfigured !== undefined &&
        !this._auth.userDetail()?.isTfaConfigured
      ) {
        this._router.navigate(['tfa']);
      }

      if (
        this._auth.userDetail().role === 'user' &&
        !this._auth.userDetail().project
      ) {
        setTimeout(() => {
          this.showProjectSelectionDialog = true;
        }, 1000);
      }
    });
  }

  mode: 'light' | 'dark' = 'light';
  switchMode() {
    if (this.mode === 'light') {
      this.mode = 'dark';
    } else {
      this.mode = 'light';
    }
    this._theme.switchMode(this.mode);
  }

  getUserDetailsAndProjects() {
    forkJoin([
      this._auth.getUserDetails(),
      this._project.getMyProjects(),
      this._auth.checkProvider(),
    ]).subscribe({
      next: (res: any) => {
        this._auth.userDetail.set(res[0]);
        this._project.projects.set(res[1]);
        this._auth.idpDetails.set(res[2]);
        this._label.fetchLabels();
        this._filter.fetchFilters();

        if (res[1].length > 0) {
          this.tenantItems = res[1].map((project: any) => {
            return {
              label: project.name,
              logo: project?.themeSettings?.logoURL,
              command: () => {
                this.changeProject(project.name);
              },
            };
          });
          this.currentProject = res[1].find(
            (project: any) => project.name === res[0].project
          );
          if (this.currentProject) {
            this._project.currentProject.set(this.currentProject);
          }
        } else {
          this.tenantItems = [
            {
              label: 'No Projects',
              disabled: true,
            },
          ];
        }

        if (
          this.currentProject &&
          this.currentProject.themeSettings &&
          this.currentProject.themeSettings.themeColor
        ) {
          this._theme.switchColor(
            this.currentProject.themeSettings.themeColor,
            'secondary'
          );
        }
        localStorage.setItem('isEnableAWB', 'false');
        localStorage.setItem('isShowExtraction', 'false');
        if (this._project.currentProject().isShowExtraction) {
          localStorage.setItem('isShowExtraction', 'true');
          this.links.push({ name: 'Extractions', url: '/extractions' });
        }
        if (this._project.currentProject().isEnableAWB) {
          localStorage.setItem('isEnableAWB', 'true');
          this.links.push({ name: 'Reports IQ', url: '/reports-iq' });
          this.links.push({ name: 'Claims', url: '/claims' });
        }


        this.isFetchingDetails = false;
        this.loading.emit(false);

        if (
          this._auth.userDetail().role === 'admin' &&
          !this._auth.userDetail().project
        ) {
          this._router.navigate(['settings/configuration']);
        }
      },
      error: (err) => {
        this.isFetchingDetails = false;
        this.loading.emit(false);
      },
    });
  }


  getUserList = () => {
    this._auth.getAllUserList().subscribe({
      next: (res: any) => {
        this._auth.userList.set(res);
        this._auth.setUserByEmail(res);
      },
      error: (err) => {
        console.log('Error', err);
      },
    });
  };

  openSettings = () => {
    this._router.navigate(['settings']);
  };

  openProductHub = () => {
    this._router.navigate(['product-hub']);
  }

  changeProject = (projectName: any) => {
    let body = {
      project: projectName,
    };

    // Filter project list to find the selected project
    const selectedProject = this._project.projects().find(
      (project: any) => project.name === projectName
    );

    // Set localStorage based on actual project settings
    if (selectedProject) {
      localStorage.setItem(
        'isEnableAWB',
        selectedProject.isEnableAWB ? 'true' : 'false'
      );
      localStorage.setItem(
        'isShowExtraction',
        selectedProject.isShowExtraction ? 'true' : 'false'
      );
    } else {
      // Default to false if project not found
      localStorage.setItem('isEnableAWB', 'false');
      localStorage.setItem('isShowExtraction', 'false');
    }

    this._project.setCurrentProject(body).subscribe({
      next: (res: any) => {
        this.showProjectSelectionDialog = false;
        this.showProjectSwitchDialog = false;
        // Remove query parameters and reload by navigating to base path
        const baseUrl = window.location.origin;
        window.location.href = baseUrl;
      },
      error: (err) => {
        console.log('Error', err);
      },
    });
  };

  logout = () => {
    this._auth.logout();
  };

  handleNotifications() {
    this.notificationService.isNotificationDialogVisible =
      !this.notificationService.isNotificationDialogVisible;
  }

  getNewNotifications() {
    this.notificationService.getNewNotifications().subscribe((data) => {
      this.newNotifications = data;
    });
  }

  handleShowAllNotifications() {
    this.isAllNotificationsVisible = !this.isAllNotificationsVisible;
  }

  handleDialogClose() {
    this.isAllNotificationsVisible = false;
    this.selectedContext = null;
    this.selectedNotificationOption = this.notificationOptions[0];
  }

  isImageLoaded: boolean = false;
  handleImageLoad = () => {
    this.isImageLoaded = true;
  };

  hideForm() {
    this.showProjectSelectionDialog = false;
  }

  getStarted() {
    this.changeProject(this.selectedProject);
  }

  updateSelectedProject() {
    this.selectedProject = this.dropdownSelect?.label;
  }

  handleRequests() {
    this._router.navigate(['requests']);
  }
}
